import { FloatingOverlay } from '@floating-ui/react'
import styled, { css } from 'styled-components'

import { media } from '@/theme/common'

// Note: This sits inside FloatingOverlay, which handles position:fixed and lockScroll
export const Overlay = styled(FloatingOverlay)<{ $isOpening: boolean; $isSuspended?: boolean }>(
  ({ theme, $isOpening, $isSuspended }) => {
    const baseStyles = css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    /*
      .navmgr (the top navbar) is never positioned/z-indexed, so it can't out-stack this
      explicitly z-indexed, positioned overlay - it always paints below, full-bleed. No space
      needs to be reserved for it.
    */
    z-index: ${theme.zIndex.level3};
    position: absolute;
    inset: 0;
    overflow: auto;
    padding: ${theme.space['20']};
    background-color: rgba(0, 0, 0, 0.5);
    opacity: 0;
    transition: opacity ${theme.transition.duration['sm']} ease-out;

    & > div[data-floating-ui-focusable] {
      overflow: auto;
    }

    // Note: matches Modal's mobile full-screen treatment (modal.styled.ts) - no padding so
    // the sheet reaches the viewport edges instead of floating as a card with a margin.
    ${media.down('sm')} {
      padding: 0;
    }
  `

    const openingStyles =
      $isOpening &&
      css`
      opacity: 1;
    `

    const suspendedStyles =
      $isSuspended &&
      css`
      display: none;
      pointer-events: none;
    `

    return css`
    ${baseStyles}
    ${openingStyles}
    ${suspendedStyles}
  `
  },
)

// Note: In-flow flex child (not position:absolute) so its transform never causes document overflow.
// Animates the dialog box into view when a modal is opened on top of a suspended one.
// When hasSuspendedBelow is false the wrapper is a transparent pass-through.
export const ContentWrapper = styled.div<{
  $isContentOpening: boolean
  $hasSuspendedBelow: boolean
}>(
  ({ theme, $isContentOpening, $hasSuspendedBelow }) => css`
    width: 100%;
    max-height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    & > div[data-floating-ui-focusable] {
      max-height: 100%;
      overflow: auto;
    }

    ${
      $hasSuspendedBelow &&
      css`
      opacity: ${$isContentOpening ? 1 : 0};
      transition: opacity ${theme.transition.duration['sm']} ease-out;
    `
    }
  `,
)
